export const checksums = {
  "index": "v3.3.0--5Wq2Z1gMZP",
  "docs": "v3.3.0--7upnrliPW4",
  "blog": "v3.3.0--gpvmfFwI9j",
  "landing": "v3.3.0--bZfVoXwPx3",
  "deploy": "v3.3.0--3M3zZmJlpp",
  "support": "v3.3.0--r4TVReDpZv",
  "agencies": "v3.3.0--IZ3yOssI2J",
  "templates": "v3.3.0--u6wDGlihzd",
  "videoCourses": "v3.3.0--RKGOq02EaH",
  "designKit": "v3.3.0--zc6wLGqeDi",
  "team": "v3.3.0--jrVTmVkAXw"
}
export const checksumsStructure = {
  "index": "UMpeZLT9rk",
  "docs": "XMWZbFhWRr",
  "blog": "mYYnoZ1bpg",
  "landing": "geAJsFqplq",
  "deploy": "lCHhFX8Yaq",
  "support": "8dQaUJonP0",
  "agencies": "DevwLiBxuG",
  "templates": "ZUtBzwpiro",
  "videoCourses": "bcjLSGLK7b",
  "designKit": "LqsbB3LagZ",
  "team": "BfpFhVpi5s"
}

export const tables = {
  "index": "_content_index",
  "docs": "_content_docs",
  "blog": "_content_blog",
  "landing": "_content_landing",
  "deploy": "_content_deploy",
  "support": "_content_support",
  "agencies": "_content_agencies",
  "templates": "_content_templates",
  "videoCourses": "_content_videoCourses",
  "designKit": "_content_designKit",
  "team": "_content_team",
  "info": "_content_info"
}

export default {
  "index": {
    "type": "data",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "hero": "json",
      "logos": "json",
      "features": "json",
      "foundation": "json",
      "modules": "json",
      "testimonial": "json",
      "deploy": "json",
      "contributors": "json",
      "stats": "json",
      "support": "json",
      "sponsors": "json"
    }
  },
  "docs": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "titleTemplate": "string",
      "links": "json"
    }
  },
  "blog": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "image": "string",
      "authors": "json",
      "date": "string",
      "draft": "boolean",
      "category": "string",
      "tags": "json"
    }
  },
  "landing": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "image": "json",
      "head": "json",
      "headline": "json",
      "links": "json",
      "cta": "json"
    }
  },
  "deploy": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "componentImg": "string",
      "logoSrc": "string",
      "featured": "boolean",
      "logoIcon": "string",
      "category": "string",
      "nitroPreset": "string",
      "website": "string"
    }
  },
  "support": {
    "type": "data",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "title": "string",
      "description": "string",
      "hero": "json",
      "logos": "json",
      "service": "json",
      "expertise": "json",
      "testimonials": "json",
      "project": "json",
      "form": "json"
    }
  },
  "agencies": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "logo": "json",
      "logoFull": "string",
      "link": "string",
      "services": "json",
      "resources": "json",
      "emailAddress": "string",
      "phoneNumber": "string",
      "x": "string",
      "github": "string",
      "linkedin": "string",
      "instagram": "string",
      "color": "json",
      "regions": "json",
      "location": "string"
    }
  },
  "templates": {
    "type": "data",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "slug": "string",
      "description": "string",
      "repo": "string",
      "demo": "string",
      "purchase": "string",
      "featured": "boolean",
      "badge": "string",
      "screenshotUrl": "string",
      "screenshotOptions": "json"
    }
  },
  "videoCourses": {
    "type": "data",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "slug": "string",
      "description": "string",
      "url": "string",
      "badge": "string",
      "screenshotOptions": "json",
      "sponsor": "boolean"
    }
  },
  "designKit": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "image": "json",
      "head": "json",
      "headline": "json",
      "links": "json",
      "cta": "json"
    }
  },
  "team": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "image": "json",
      "head": "json",
      "headline": "json",
      "links": "json",
      "cta": "json",
      "users": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}